export default __webpack_public_path__ + "media/flutter.67afc82a.svg";